module.exports = __webpack_public_path__ + "static/reason_free-197b03037aeb39c9b508967bd14a0029.png";